import { Trans } from '@kit/ui/trans';

import type { DancerListItem } from '../_lib/server/get-dancers';
import { DancerCard } from './dancer-card';

interface DancerGridProps {
  dancers: DancerListItem[];
  isLoading?: boolean;
  /** Super-admin only (BAL-392) — forwarded to each DancerCard. */
  showAdminEdit?: boolean;
}

const PRIORITY_COUNT = 8;

export function DancerGrid({
  dancers,
  isLoading,
  showAdminEdit = false,
}: DancerGridProps) {
  if (dancers.length === 0 && !isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-4">
        <div className="max-w-sm space-y-2 text-center">
          <p className="text-foreground text-base font-medium">
            <Trans i18nKey="dancers:empty.title" defaults="No dancers found" />
          </p>
          <p className="text-muted-foreground text-sm">
            <Trans
              i18nKey="dancers:empty.subtitle"
              defaults="Try adjusting your filters"
            />
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4">
      <div
        className="grid grid-cols-2 gap-x-4 gap-y-6 transition-opacity duration-200 data-[loading=true]:opacity-60 sm:grid-cols-3 sm:gap-x-5 sm:gap-y-8 md:grid-cols-4 lg:grid-cols-5"
        data-loading={isLoading ? 'true' : 'false'}
      >
        {dancers.map((dancer, index) => (
          <DancerCard
            key={dancer.id}
            dancer={dancer}
            priority={index < PRIORITY_COUNT}
            showAdminEdit={showAdminEdit}
          />
        ))}
      </div>
    </div>
  );
}
